<template>
  <c-box :mb="{ base: '-sm', lg: '0' }">
    <FrontpageHeroReactConnector v-if="partnerName" v-chakra :mt="{ base: '3xl', xl: '3rem' }" />

    <ShortListBulletin v-if="hasBulletin" v-chakra :mt="{ base: '4xl', lg: '4xl' }" />

    <c-box v-if="isOrderingAllowed" mt="4xl">
      <CurrentOrdersAndReturns v-chakra mt="3xl" />
    </c-box>

    <News v-chakra mt="4xl" />
  </c-box>
</template>

<script lang="ts">
import ContactPerson from "@/components/ContactPerson.vue";
import CurrentOrdersAndReturns from "@/views/CurrentOrdersAndReturns.vue";
import News from "@/views/News.vue";
import ShortListBulletin from "@/views/ShortListBulletin.vue";
import { CBox, CDivider, CFlex, CHeading, CText } from "@chakra-ui/vue";
import { CorePermission, IRootState } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapState } from "vuex";
import FrontpageHeroReactConnector from "./FrontpageHeroReactConnector.vue";

export default defineComponent({
  name: "Frontpage",
  components: {
    News,
    ContactPerson,
    ShortListBulletin,
    CurrentOrdersAndReturns,
    CBox,
    CFlex,
    CHeading,
    CText,
    CDivider,
    FrontpageHeroReactConnector,
  },
  computed: {
    ...mapState({
      user: (state: unknown) => (state as IRootState).user!,
      partnerName: (state: unknown) => (state as IRootState).partnerInfo?.partnerInfo?.partnerName,
    }),
    greeting(): string {
      const greetingKey = `frontpage.mainContent.greetings.hour${new Date().getHours()}`;
      return `${this.$t(greetingKey)} ${(this as any).user.firstName}`;
    },
    isOrderingAllowed(): boolean {
      return (this as any).user.hasPermissions([CorePermission.order]);
    },
    hasBulletin(): boolean {
      return this.$store.state.bulletin.all.length > 0;
    },
    classForContactPerson(): any {
      const hasBulletin = this.hasBulletin;
      return {
        "content-container": true,
        "col-md-5": hasBulletin,
        "col-md-12": !hasBulletin,
      };
    },
  },
  methods: {
    navigate(path: string) {
      this.$router.push({ path });
    },
  },
});
</script>
